<aimo-cx-navigation-ui [node]="node$ | async" [ngClass]="styleClass$ | async"> </aimo-cx-navigation-ui>
